import { ActionType } from '~/dashboard/views/workflows/store/engine/constants';
import type { PublishedAttributeModifiedChange } from './types';

// sdk changes don't belong to an Action, but still need an ID to group them by
export const FAKE_ACTION_ID_FOR_SDK = '@@__FAKE_ACTION_ID_FOR_SDK__@@';

// failure handling mode changes don't belong to an Action, but still need an ID to group them by
export const FAKE_ACTION_ID_FOR_FAILURE_HANDLING_MODE = '@@__FAKE_ACTION_ID_FOR_FAILURE_HANDLING_MODE__@@';

// array of supported changelog fields for inputs
export const SUPPORTED_INPUT_METADATA_FIELDS = [
  'name',
  'dataType',
  'jqFunction',
] as const; // todo - add `satisfies (keyof Action['input'])[]`; when our TS version supports it

// creates an immutable array that is a sub-set of the supported fields
export const OPTIONAL_SUPPORTED_INPUT_METADATA_FIELDS: ReadonlyArray<
  typeof SUPPORTED_INPUT_METADATA_FIELDS[number]> = ['jqFunction'];


// array of supported changelog fields for outputs
export const SUPPORTED_OUTPUT_METADATA_FIELDS = [
  'name',
  'dataType',
  'jqFunction',
  'useJq',
] as const; // todo - add `satisfies (keyof Action['input'])[]`; when our TS version supports it


export const VALUE_RANGE_OPTION_FIELD = 'output_value_range';
export const SUPPORTED_VALUE_RANGE_OPTIONS = [
  'color',
  'label',
  'maxValue',
  'minValue',
];

export const SUPPORTED_OUTPUT_OPTION_FIELDS = [
  VALUE_RANGE_OPTION_FIELD,
  'category',
];

// creates an immutable array that is a sub-set of the supported fields
export const OPTIONAL_SUPPORTED_OUTPUT_METADATA_FIELDS: ReadonlyArray<
  typeof SUPPORTED_INPUT_METADATA_FIELDS[number]> = ['jqFunction'];


export const SUPPORTED_ATTRIBUTE_FIELDS_MAP = {
  [ActionType.INPUT]: SUPPORTED_INPUT_METADATA_FIELDS,
  [ActionType.OUTPUT]: SUPPORTED_OUTPUT_METADATA_FIELDS,
};

export const SUPPORTED_ATTRIBUTE_OPTIONS_MAP = {
  [ActionType.INPUT]: [],
  [ActionType.OUTPUT]: SUPPORTED_OUTPUT_OPTION_FIELDS,
};

export const OPTIONAL_ATTRIBUTE_FIELDS_MAP = {
  [ActionType.INPUT]: OPTIONAL_SUPPORTED_INPUT_METADATA_FIELDS,
  [ActionType.OUTPUT]: OPTIONAL_SUPPORTED_OUTPUT_METADATA_FIELDS,
};


export const SUPPORTED_PA_METADATA_FIELDS: ReadonlyArray<(
  keyof PublishedAttributeModifiedChange['value']['next'])
> = ['defaultValue', 'hasExpiration', 'valueExpiresInDays'];


export const SUPPORTED_TAG_GLOBAL_SETTINGS_FIELDS = [
  'categoryName',
  'color',
  'description',
  'isAdverseActionReason',
  'isCaseCreating',
  'name',
  'outcomes',
  'suppressionInterval',
]; // todo - add `satisfies (keyof TagActionGlobalSettingsModifiedChange['value']['next'])[]
